import { render, staticRenderFns } from "./EchartAnnular.vue?vue&type=template&id=2ab36d35"
import script from "./EchartAnnular.vue?vue&type=script&lang=js"
export * from "./EchartAnnular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports